// extracted by mini-css-extract-plugin
module.exports = {"aside":"Aside_aside__1DhXj"};